var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import { themeit } from 'react-themeit';

import MediaController from '../MediaController';
import LoadingSpinner from '../LoadingSpinner';

import baseStyle from './styles.less';
import _taskQuestion from './themes/taskQuestion.less';

var themeOptions = {
  base: function base(cb) {
    return cb(baseStyle);
  },
  themes: {
    taskQuestion: function taskQuestion(cb) {
      return cb(_taskQuestion);
    }
  }
};

var Audio = function (_Component) {
  _inherits(Audio, _Component);

  function Audio(props) {
    _classCallCheck(this, Audio);

    var _this = _possibleConstructorReturn(this, (Audio.__proto__ || Object.getPrototypeOf(Audio)).call(this, props));

    _this.updateDimensions = function () {
      _this.setState({
        numOfBars: _this.$bars ? Math.floor((_this.$bars.offsetWidth - 35) / 20) : 0
      }, function () {
        return _this.createBars();
      });
    };

    _this.onLoadedMetadata = function () {
      _this.setState({
        mediadataLoaded: true
      });
    };

    _this.onCanPlay = function () {
      if (_this.$player.duration === Infinity) {
        // fix in which currentTime is set to a time long past the end of the clip
        // (1 day should be safe)
        _this.$player.currentTime = 60 * 60 * 24;
      }
      _this.setState({
        ready: true
      });
    };

    _this.onTimeUpdate = function () {
      if (!_this.state.seeking) {
        _this.setState({
          elapsed: _this.$player.currentTime / _this.$player.duration
        });
      }
    };

    _this.toggleMusic = function () {
      var toggleAudioSource = _this.props.toggleAudioSource;

      _this.setState({
        playing: false,
        elapsed: 0,
        mediadataLoaded: false,
        ready: false,
        source: toggleAudioSource()
      });
      _this.$player.pause();
      _this.$player.load();
    };

    _this.onPlay = function () {
      _this.setState({
        playing: true
      });
      _this.changeHeight();
    };

    _this.onPause = function () {
      _this.setState({
        playing: false
      });
      _this.changeHeight(true);
    };

    _this.onEnded = function () {
      _this.setState({
        playing: false,
        elapsed: 0
      });
    };

    _this.onSeekMouseDown = function () {
      _this.setState({ seeking: true });
    };

    _this.onSeekChange = function (e) {
      _this.setState({ elapsed: parseFloat(e.target.value) });
    };

    _this.onSeekMouseUp = function (e) {
      _this.setState({
        seeking: false
      });
      _this.$player.currentTime = parseFloat(e.target.value) * _this.$player.duration;
    };

    _this.setPlayingState = function (playState) {
      if (playState && _this.$player.paused) {
        _this.$player.play();
      } else {
        _this.$player.pause();
      }
    };

    _this.setToPosition = function (value) {
      _this.$player.currentTime = parseFloat(value);
    };

    _this.changeHeight = function () {
      var stop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var theme = _this.props.theme;

      var maxHeight = theme === 'taskQuestion' ? 30 : 70;
      for (var index = 0; index < _this.$bars.firstChild.children.length; index += 1) {
        var child = _this.$bars.firstChild.children[index];
        var height = '0%';
        if (stop) {
          height = child.offsetHeight + 'px';
        } else if (parseInt(child.style.height, 10) < maxHeight) {
          height = maxHeight + '%';
        } else {
          height = '10%';
        }
        child.style.height = height;
      }
    };

    _this.barTransitionEnd = function (e) {
      var theme = _this.props.theme;

      var maxHeight = theme === 'taskQuestion' ? 40 : 80;
      if (_this.state.playing) {
        var height = '0%';
        if (parseInt(e.target.style.height, 10) < maxHeight) {
          height = maxHeight + '%';
        } else {
          height = '10%';
        }
        e.target.style.height = height;
      }
    };

    _this.state = {
      numOfBars: 0,
      playing: false,
      elapsed: 0,
      mediadataLoaded: false,
      ready: false,
      source: props.src
    };
    _this.durationOptions = [];
    _this.throttledResize = debounce(_this.updateDimensions, 200);
    _this.$player = null;
    return _this;
  }

  _createClass(Audio, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      var id = this.props.id;

      if (this.$player && (id !== nextProps.id || this.context.enteredAnswer !== null && nextContext.enteredAnswer === null)) {
        this.setState({
          playing: false,
          elapsed: 0,
          mediadataLoaded: false,
          ready: false,
          source: nextProps.src
        });
        this.$player.pause();
        this.$player.load();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.throttledResize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.throttledResize);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.mediadataLoaded !== this.state.mediadataLoaded || prevState.numOfBars !== this.state.numOfBars) {
        this.updateDimensions();
      }
    }
  }, {
    key: 'createBars',
    value: function createBars() {
      var _props = this.props,
          styles = _props.styles,
          theme = _props.theme;
      var numOfBars = this.state.numOfBars;

      var maxHeight = theme === 'taskQuestion' ? 30 : 70;
      this.durationOptions = [];
      var barContainer = document.createElement('div');
      barContainer.className = styles.paddingDiv;
      for (var i = 0; i < numOfBars; i += 1) {
        var bar = document.createElement('div');
        bar.className = styles.bar;
        bar.style.height = Math.floor(Math.random() * maxHeight) + 10 + '%';
        bar.style.transitionDuration = Math.floor(Math.random() * 350) + 300 + 'ms';
        bar.addEventListener('transitionend', this.barTransitionEnd, false);
        barContainer.appendChild(bar);
      }
      if (this.$bars && !this.$bars.hasChildNodes()) {
        this.$bars.appendChild(barContainer);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          styles = _props2.styles,
          id = _props2.id,
          theme = _props2.theme,
          vocalsIcon = _props2.vocalsIcon,
          toggleAudioSource = _props2.toggleAudioSource;
      var _state = this.state,
          ready = _state.ready,
          mediadataLoaded = _state.mediadataLoaded,
          playing = _state.playing,
          elapsed = _state.elapsed,
          source = _state.source;

      var showController = mediadataLoaded && !ready || ready;
      return React.createElement(
        'div',
        { className: styles.audioContainer, role: 'button' },
        React.createElement('div', {
          className: styles.barsContainer,
          ref: function ref(bars) {
            _this2.$bars = bars;
          }
        }),
        React.createElement(
          'audio',
          {
            key: source,
            preload: 'auto',
            controls: false,
            controlsList: 'nodownload',
            autoPlay: false,
            onLoadedMetadata: this.onLoadedMetadata,
            onCanPlay: this.onCanPlay,
            onLoadedData: this.onLoadedData,
            onTimeUpdate: this.onTimeUpdate,
            onPlay: this.onPlay,
            onPause: this.onPause,
            onEnded: this.onEnded,
            ref: function ref(player) {
              _this2.$player = player;
            }
          },
          React.createElement('source', { src: source })
        ),
        showController ? React.createElement(MediaController, {
          id: id,
          theme: theme,
          playing: playing,
          elapsed: elapsed,
          duration: this.$player.duration,

          toggleAudioSource: this.toggleMusic,
          hasSourceToggle: !!toggleAudioSource,
          vocalsIcon: vocalsIcon,

          onSeekMouseDown: this.onSeekMouseDown,
          onSeekChange: this.onSeekChange,
          onSeekMouseUp: this.onSeekMouseUp,
          setPlayingState: this.setPlayingState,
          setToPosition: this.setToPosition
        }) : React.createElement(LoadingSpinner, null)
      );
    }
  }]);

  return Audio;
}(Component);

Audio.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  theme: PropTypes.string,
  toggleAudioSource: PropTypes.func,
  vocalsIcon: PropTypes.bool,
  styles: PropTypes.objectOf(PropTypes.string)
} : {};

Audio.defaultProps = {
  theme: null,
  toggleAudioSource: null,
  vocalsIcon: true,
  styles: null
};

Audio.contextTypes = {
  setAnswer: PropTypes.func,
  enteredAnswer: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))])
};

export default themeit(themeOptions)(Audio);